import React from 'react';
import PropTypes from 'prop-types';
import ShapedButton from './ShapedButton';
import GreenArrowIcon from '../../images/vector/green-arrow-icon.svg';
import GreyArrowIcon from '../../images/vector/grey-arrow-icon.svg';

const ArrowButton = props => {
    const styles = `${props.pointingDirection}-arrow${props.isEnabled ? '' : ' disabled-button'}`;
    return (
        <ShapedButton
            ariaLabel={props.ariaLabel}
            styles={styles}
            onClick={props.onClick}
            isEnabled={props.isEnabled}
        >
            {props.pointingDirection === 'left' ? (
                <GreyArrowIcon className="svg-triangle-button lantern-svg" />
            ) : (
                <GreenArrowIcon className="svg-triangle-button lantern-svg" />
            )}
        </ShapedButton>
    );
};

ArrowButton.propTypes = {
    ariaLabel: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    isEnabled: PropTypes.bool,
    pointingDirection: PropTypes.string,
};

ArrowButton.defaultProps = {
    ariaLabel: '',
    isEnabled: true,
    pointingDirection: '',
};

export default ArrowButton;
